// Cómo se lee una dirección de sucursal.
//
// Módulo aparte del componente de mapa a propósito: son funciones puras que
// usan también el listado y el formulario, y mezclarlas con un componente
// rompe la recarga en caliente de Vite.

export function tieneCoordenadas(s) {
  return s?.latitud !== null && s?.latitud !== undefined && s?.latitud !== ''
    && s?.longitud !== null && s?.longitud !== undefined && s?.longitud !== '';
}

// Arma la dirección de una línea a partir de los campos estructurados, y
// si no hay ninguno cae al campo libre que existía antes de la migración
// 020. Conviven a propósito: nadie va a reteclear cincuenta direcciones.
export function direccionLegible(s) {
  if (!s) return '';
  const calle = [s.calle, s.numero_exterior].filter(Boolean).join(' ');
  const interior = s.numero_interior ? `int. ${s.numero_interior}` : null;
  const partes = [
    [calle, interior].filter(Boolean).join(' '),
    s.colonia,
    [s.codigo_postal, s.municipio].filter(Boolean).join(' '),
    s.estado,
    s.pais && s.pais !== 'Mexico' ? s.pais : null,
  ].filter(Boolean);
  return partes.length ? partes.join(', ') : (s.direccion || '');
}

// Falta una de las dos coordenadas.
//
// La regla estaba escrita DENTRO del `onConfirmar` del formulario, o sea
// que solo se enteraba uno al pulsar Guardar, y llegaba como un banner
// rojo arriba del todo — a buscar cuál de los dos campos era. Aquí es una
// función pura que el propio campo puede consultar al salir de él.
export function faltaPar(s) {
  const lat = String(s?.latitud ?? '').trim();
  const lon = String(s?.longitud ?? '').trim();
  if (Boolean(lat) === Boolean(lon)) return null;
  return lat
    ? 'Falta la longitud: con una sola coordenada no se ubica nada.'
    : 'Falta la latitud: con una sola coordenada no se ubica nada.';
}
